import type { ComponentType, SVGProps } from 'react';

import './module-hero.css';

type ModuleHeroTone = 'vaccination' | 'store' | 'blood-bank';

interface ModuleHeroProps {
  eyebrow: string;
  title: string;
  description: string;
  icon: ComponentType<SVGProps<SVGSVGElement>>;
  tone: ModuleHeroTone;
}

export const ModuleHero = ({ eyebrow, title, description, icon: Icon, tone }: ModuleHeroProps) => (
  <header className={`page-heading module-hero module-hero-${tone}`}>
    <span className="module-hero-icon" aria-hidden="true"><Icon /></span>
    <div className="module-hero-content">
      <span className="eyebrow">{eyebrow}</span>
      <h1>{title}</h1>
      <p>{description}</p>
    </div>
  </header>
);
